import { gql } from "@apollo/client";

export const GET_COMPLETED_APPLICATIONS = gql`
  query GetCompletedApplications($since: Date!) {
    completedApplicationsByMonth(since: $since) {
      month
      count
    }
  }
`;

export const USER_ACCOUNT_STATS = gql`
  query UserAccountStatistics {
    userAccountStatistics {
      createdThisWeek
      createdToday
      total
    }
  }
`;

export const APPLICATION_STATS = gql`
  query ApplicationStatistics {
    applicationStatistics {
      createdToday
      createdThisWeek
      total
    }
  }
`;

export const PROPERTY_COUNT = gql`
  query PropertyCount {
    propertyCount
  }
`;
export const PM_USER_COUNT = gql`
  query PMUserCount {
    pmUserCount
  }
`;
export const ADMIN_USER_COUNT = gql`
  query AdminUserCount {
    adminUserCount
  }
`;
